export default __webpack_public_path__ + "static/media/Turbulent Warhack.4ac0d5aa.jpg";